import React, { useState } from "react";
import { Button, Form, Container, Row, Col, Alert } from "react-bootstrap";
import "./KYCApprovalComponent.css";

const KYCApprovalComponent = () => {
  const [formData, setFormData] = useState({
    mobile: "",
    sDate: "",
    eDate: "",
    type: "",
    documentType: "",
  });

  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.mobile && formData.type && formData.documentType) {
      console.log("Form Data Submitted:", formData);
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000); // Hide alert after 3 seconds
    }
  };

  return (
    <Container className="kyc-container mt-5">
      <Row>
        {/* Left-Aligned Content */}
        <Col md={6}>
         

          {/* Success Alert */}
          {showAlert && (
            <Alert variant="success" className="text-center">
              KYC details submitted successfully!
            </Alert>
          )}

          {/* KYC Approval Form */}
          <Form onSubmit={handleSubmit} className="shadow-lg p-4 rounded bg-light">
            <Row className="mb-4">
              <Col md={12}>
                <Form.Group controlId="formMobile">
                  <Form.Label>Search Mobile</Form.Label>
                  <Form.Control
                    type="text"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="Enter Mobile Number"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={6}>
                <Form.Group controlId="formSDate">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="sDate"
                    value={formData.sDate}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formEDate">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="eDate"
                    value={formData.eDate}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={12}>
                <Form.Group controlId="formType">
                  <Form.Label>Type</Form.Label>
                  <Form.Control
                    as="select"
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="individual">Individual</option>
                    <option value="corporate">Corporate</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={12}>
                <Form.Group controlId="formDocumentType">
                  <Form.Label>Document Type</Form.Label>
                  <Form.Control
                    as="select"
                    name="documentType"
                    value={formData.documentType}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Document Type</option>
                    <option value="passport">Passport</option>
                    <option value="aadhaar">Aadhaar</option>
                    <option value="driving_license">Driving License</option>
                    <option value="voter_id">Voter ID</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-start">
              <Button variant="primary" type="submit" className="px-4">
                Submit
              </Button>
            </div>
          </Form>
        </Col>
        {/* Optional Right-Side Space */}
        <Col md={6}></Col>
      </Row>
    </Container>
  );
};

export default KYCApprovalComponent;
